<!-- 個人設定では <label>（項目名）の中に置くため、クリックの既定動作を止める。
     止めないと、ラベルがクリックを中のボタンなどにも送り、開いた直後に閉じるなどの誤動作になる -->
<div class="permission-trigger" (click)="toggle(); $event.preventDefault()">
  <mat-icon class="icon" [style.font-size.px]="iconSize" [style.width.px]="iconSize" [style.height.px]="iconSize" [style.line-height.px]="iconSize">info</mat-icon>
  <ng-container *ngIf="triggerLabel">{{ triggerLabel }}</ng-container>
</div>

@if (isOpen) {
  <div class="permission-overlay" (click)="toggle(); $event.preventDefault()">
    <div class="permission-panel" (click)="$event.stopPropagation(); $event.preventDefault()">

      <table class="permission-table">
          <thead>
            <tr>
              <th>権限名</th>
              <th>アカウント<span class="sp-only">管理</span><span class="th-detail"><br>権限変更 / パスワードリセット / 削除</span></th>
              <th class="th-org"><span class="phrase">組織情報<span class="pc-slash"> /&nbsp;</span></span><span class="phrase">マスタ設定</span><span class="th-detail"><br>登録・編集など</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>管理</td>
              <td>○</td>
              <td>○</td>
            </tr>
            <tr>
              <td>準管理</td>
              <td><span class="phrase">「運用」以下の</span><span class="phrase">ユーザーに</span><span class="phrase">対して可能</span></td>
              <td>○</td>
            </tr>
            <tr>
              <td>運用</td>
              <td><span class="phrase">「メンバー」以下の</span><span class="phrase">ユーザーに</span><span class="phrase">対して可能</span></td>
              <td>×</td>
            </tr>
            <tr>
              <td>メンバー</td>
              <td>×</td>
              <td>×</td>
            </tr>
            <tr>
              <td>なし（未承認）</td>
              <td>×</td>
              <td>×</td>
            </tr>
          </tbody>
      </table>

    </div>
  </div>
}
